// @src/pre-deployment/src/services/firebase.js v1.2
// - Firebase configuration for pre-deployment environment
// - Self-contained Firebase setup with same configuration as main app
// - Enhanced error handling and initialization safety
// - Added Firebase Storage export for image upload functionality

import { initializeApp } from "firebase/app";
import { getAuth, sendSignInLinkToEmail } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

console.group('🔥 PRE-DEPLOYMENT: Firebase configuration');
console.log('Initializing Firebase for pre-deployment...');

// Firebase configuration with fallbacks
const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY || "AIzaSyCggmB8n0iKb265zzQKCakSTSjz9AjXdTA",
    authDomain: process.env.REACT_APP_AUTH_DOMAIN || "landingpagedemo-8c93d.firebaseapp.com",
    projectId: process.env.REACT_APP_PROJECT_ID || "landingpagedemo-8c93d",
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET || "landingpagedemo-8c93d.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || "712287954392",
    appId: process.env.REACT_APP_APP_ID || "1:712287954392:web:0381bde0cf84ba800dbead",
    measurementId: process.env.REACT_APP_MEASUREMENT_ID || "G-G5S9GKL8XD",
};

console.log('Firebase config loaded:', {
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain,
    storageBucket: firebaseConfig.storageBucket,
    hasApiKey: !!firebaseConfig.apiKey
});

// Initialize Firebase with error handling
let app, auth, db, storage, functions;



try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);
    functions = getFunctions(app);

    console.log('[Firebase] Services initialized successfully:');
    console.log('Auth:', !!auth);
    console.log('Firestore:', !!db);
    console.log('Storage:', !!storage);
    console.log('Functions:', !!functions);


} catch (error) {
    console.error('❌ Firebase initialization failed:', error);
    // Create fallback objects to prevent app crashes
    app = null;
    auth = null;
    db = null;
    storage = null;
    functions = null;


}

console.groupEnd();

export { auth, db, storage, functions, sendSignInLinkToEmail };
